import React from "react";
import { View, Text, Image, ScrollView, StyleSheet } from "react-native";
import { useTranslation } from "react-i18next";
import RenderHTML from "react-native-render-html";
import SvaraModal from "./SvaraModal";
import { BtnSidebarClosePng, GameRulesLight } from "../../../assets";

interface TournamentRulesModalProps {
  visible: boolean;
  onClose: () => void;
  isDesktop: boolean;
  width: number;
}

const TournamentRulesModal: React.FC<TournamentRulesModalProps> = ({
  visible,
  onClose,
  isDesktop,
  width,
}) => {
  const { t } = useTranslation();
  const tournamentRulesHtml = t("T_SITE_GAME_TOURNAMENT_RULES_CONTENT");

  return (
    <SvaraModal
      visible={visible}
      onClose={onClose}
      closeIcon={BtnSidebarClosePng}
    >
      <ScrollView
        style={{ maxHeight: 500 }}
        contentContainerStyle={{
          paddingHorizontal: isDesktop ? 80 : 20,
          paddingTop: 0,
          paddingBottom: 40,
          maxWidth: isDesktop ? 1000 : width * 0.8,
        }}
        showsVerticalScrollIndicator
        nestedScrollEnabled
      >
        <Text
          style={{
            fontSize: 24,
            fontWeight: "bold",
            color: "#fff",
            textAlign: "center",
            marginBottom: 16,
          }}
        >
          {t("T_SITE_GAME_TOURNAMENT_RULES_TITLE")}
        </Text>

        <Image
          source={GameRulesLight}
          style={{ width: "100%", height: isDesktop ? 12 : 8 }}
          resizeMode="stretch"
        />

        <RenderHTML
          contentWidth={isDesktop ? 800 : width * 0.75}
          source={{ html: tournamentRulesHtml }}
          tagsStyles={{
            h1: {
              fontSize: 28,
              color: "#fff",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            },
            h2: {
              fontSize: 24,
              color: "#fff",
              fontWeight: "bold",
              marginBottom: 12,
              textAlign: "center",
            },
            p: {
              fontSize: 16,
              color: "#fff",
              textAlign: "left",
              marginBottom: 8,
            },
            li: {
              fontSize: 16,
              color: "#fff",
              marginBottom: 4,
            },
          }}
        />
      </ScrollView>
    </SvaraModal>
  );
};

export default TournamentRulesModal;

